import React, { useState } from 'react';
import { Box, Button, CircularProgress, Tabs, Tab, Typography, MenuItem, Select, InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import image1 from '../assets/image1.png';
import image2 from '../assets/image2.png';
import Navbar from '../components/Navbar';

const CustomSelect = styled(Select)(({ theme }) => ({
  backgroundColor: '#23272f',
  color: '#fff',
  borderRadius: 8,
  minWidth: 120,
  height: 40,
  boxShadow: 'none',
  '.MuiSelect-icon': {
    color: '#fff',
    right: 12,
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInputBase-input': {
    padding: '10px 16px',
  },
}));

const OptionBar = styled('div')({
  background: '#23272f',
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  padding: '8px 16px',
  marginBottom: 20,
  minHeight: 52,
  position: 'relative',
});
const OptionBarDropdown = styled(CustomSelect)({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  minWidth: 120,
});

export default function Fibre() {
  const [processing, setProcessing] = useState(false);
  const [processed, setProcessed] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleProcess = () => {
    setProcessing(true);
    setTimeout(() => {
      setProcessing(false);
      setProcessed(true);
    }, 3000);
  };

  // Add Building Attributes table under Building Attributes tab
  const buildingAttributesData = [
    {
      buildingNumber: 0,
      buildingType: "Single Family Home",
      houseNumber: 1714,
      roadName: "Minley Way",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7207,
      longitude: -78.8594,
      googleMaps: "https://maps.google.com/?q=35.7207,-78.8594",
      streetView: "https://www.google.com/maps/@35.7207,-78.8594,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 1,
      buildingType: "Single Family Home",
      houseNumber: 1300,
      roadName: "Padstone Drive",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7174,
      longitude: -78.8593,
      googleMaps: "https://maps.google.com/?q=35.7174,-78.8593",
      streetView: "https://www.google.com/maps/@35.7174,-78.8593,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 2,
      buildingType: "Single Family Home",
      houseNumber: 1801,
      roadName: "Broomhurst Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7175,
      longitude: -78.8602,
      googleMaps: "https://maps.google.com/?q=35.7175,-78.8602",
      streetView: "https://www.google.com/maps/@35.7175,-78.8602,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 3,
      buildingType: "Single Family Home",
      houseNumber: 1412,
      roadName: "Wragby Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7199,
      longitude: -78.8602,
      googleMaps: "https://maps.google.com/?q=35.7199,-78.8602",
      streetView: "https://www.google.com/maps/@35.7199,-78.8602,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 4,
      buildingType: "Single Family Home",
      houseNumber: 1811,
      roadName: "Broomhurst Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7174,
      longitude: -78.8605,
      googleMaps: "https://maps.google.com/?q=35.7174,-78.8605",
      streetView: "https://www.google.com/maps/@35.7174,-78.8605,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 5,
      buildingType: "Single Family Home",
      houseNumber: 1718,
      roadName: "Minley Way",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7205,
      longitude: -78.8594,
      googleMaps: "https://maps.google.com/?q=35.7205,-78.8594",
      streetView: "https://www.google.com/maps/@35.7205,-78.8594,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 6,
      buildingType: "Single Family Home",
      houseNumber: 1340,
      roadName: "Padstone Drive",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7184,
      longitude: -78.8608,
      googleMaps: "https://maps.google.com/?q=35.7184,-78.8608",
      streetView: "https://www.google.com/maps/@35.7184,-78.8608,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 7,
      buildingType: "Single Family Home",
      houseNumber: 1406,
      roadName: "Wragby Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7201,
      longitude: -78.8598,
      googleMaps: "https://maps.google.com/?q=35.7201,-78.8598",
      streetView: "https://www.google.com/maps/@35.7201,-78.8598,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 8,
      buildingType: "Single Family Home",
      houseNumber: 1810,
      roadName: "Broomhurst Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7177,
      longitude: -78.8608,
      googleMaps: "https://maps.google.com/?q=35.7177,-78.8608",
      streetView: "https://www.google.com/maps/@35.7177,-78.8608,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    },
    {
      buildingNumber: 9,
      buildingType: "Single Family Home",
      houseNumber: 1422,
      roadName: "Wragby Lane",
      city: "Apex",
      state: "North Carolina",
      zip: 27502,
      country: "United States",
      latitude: 35.7196,
      longitude: -78.8606,
      googleMaps: "https://maps.google.com/?q=35.7196,-78.8606",
      streetView: "https://www.google.com/maps/@35.7196,-78.8606,3a,75y,90t/data=!3m6!1e1!3m4!1s..."
    }
  ];

  // Remove icon and heading from Building Attributes tab
  function BuildingAttributesTable() {
    return (
      <div style={{ padding: '20px' }}>
        <table style={{ width: '100%', background: '#23272f', color: '#fff', borderRadius: 10, overflow: 'hidden' }}>
          <thead>
            <tr>
              <th>Building #</th>
              <th>Building Type</th>
              <th>House #</th>
              <th>Road Name</th>
              <th>City</th>
              <th>State</th>
              <th>Zip</th>
              <th>Country</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th>Google Maps</th>
              <th>Streetview Image</th>
            </tr>
          </thead>
          <tbody>
            {buildingAttributesData.map((row, idx) => (
              <tr key={idx}>
                <td>{row.buildingNumber}</td>
                <td>{row.buildingType}</td>
                <td>{row.houseNumber}</td>
                <td>{row.roadName}</td>
                <td>{row.city}</td>
                <td>{row.state}</td>
                <td>{row.zip}</td>
                <td>{row.country}</td>
                <td>{row.latitude}</td>
                <td>{row.longitude}</td>
                <td><a href={row.googleMaps} target="_blank" rel="noopener noreferrer" style={{ color: '#4fc3f7' }}>Open Map</a></td>
                <td><a href={row.streetView} target="_blank" rel="noopener noreferrer" style={{ color: '#4fc3f7' }}>View Image</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // Add Material Cost Breakdown table under Material Cost Breakdown tab
  const materialCostData = [
    { type: "Fiber Cable", quantity: 6, quantityUnits: "", totalCost: "$3,552.60" },
    { type: "POP", quantity: 1, quantityUnits: "", totalCost: "$500.00" },
    { type: "Terminal", quantity: 19, quantityUnits: "", totalCost: "$4,750.00" },
    { type: "Flowerpot", quantity: 68, quantityUnits: "", totalCost: "$3,060.00" },
    { type: "ONT", quantity: 133, quantityUnits: "", totalCost: "$9,310.00" }
  ];

  const materialCostOptions = [
    { value: 'quantity', label: 'Quantity' },
    { value: 'quantityUnits', label: 'Quantity units' },
    { value: 'totalCost', label: 'Total Cost' }
  ];

  function MaterialCostBreakdownTable() {
    const [selectedOptions, setSelectedOptions] = useState(['quantity', 'quantityUnits', 'totalCost']);
    const [dropdownValue, setDropdownValue] = useState('totalCost');

    return (
      <div style={{ padding: '20px' }}>
        <div style={{ color: '#fff', marginBottom: 10 }}>Select dataframe columns</div>
        <OptionBar>
          <div>
            {selectedOptions.map(opt => (
              <span key={opt} style={{ background: '#ef5350', color: '#fff', borderRadius: 6, padding: '6px 12px', marginRight: 8, fontSize: 16 }}>{materialCostOptions.find(o => o.value === opt)?.label} &#10005;</span>
            ))}
          </div>
          <OptionBarDropdown
            value={dropdownValue}
            onChange={e => {
              setDropdownValue(e.target.value);
              if (!selectedOptions.includes(e.target.value)) {
                setSelectedOptions([...selectedOptions, e.target.value]);
              }
            }}
            displayEmpty
            input={<InputBase />}
          >
            {materialCostOptions.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </OptionBarDropdown>
        </OptionBar>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', background: '#23272f', color: '#fff', borderRadius: 10, borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Type</th>
                {selectedOptions.includes('quantity') && <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Quantity</th>}
                {selectedOptions.includes('quantityUnits') && <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Quantity units</th>}
                {selectedOptions.includes('totalCost') && <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Total Cost</th>}
              </tr>
            </thead>
            <tbody>
              {materialCostData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.type}</td>
                  {selectedOptions.includes('quantity') && <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.quantity}</td>}
                  {selectedOptions.includes('quantityUnits') && <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.quantityUnits}</td>}
                  {selectedOptions.includes('totalCost') && <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.totalCost}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ color: '#fff', fontSize: 32, textAlign: 'center', marginTop: 30 }}>
          €21,172.60
        </div>
      </div>
    );
  }

  // Add Labour Cost Breakdown table under Labour Cost Breakdown tab
  const labourCostData = [
    { type: "Road-Side Trench", quantity: 2, quantityUnits: "", totalCost: "$40,414.00" },
    { type: "Road-Crossing Trench", quantity: 43, quantityUnits: "", totalCost: "$11,489,600.00" },
    { type: "To Building Trench", quantity: 3, quantityUnits: "", totalCost: "$45,758.00" },
    { type: "Fiber Cable", quantity: 6, quantityUnits: "", totalCost: "$3,552.60" },
    { type: "POP", quantity: 1, quantityUnits: "", totalCost: "$150.00" },
    { type: "Terminal", quantity: 19, quantityUnits: "", totalCost: "$1,425.00" },
    { type: "Flowerpot", quantity: 68, quantityUnits: "", totalCost: "$2,040.00" },
    { type: "ONT", quantity: 133, quantityUnits: "", totalCost: "$11,426.03" }
  ];

  function LabourCostBreakdownTable() {
    const [selectedOptions, setSelectedOptions] = useState(['quantity', 'quantityUnits', 'totalCost']);
    const [dropdownValue, setDropdownValue] = useState('totalCost');

    return (
      <div style={{ padding: '20px' }}>
        <div style={{ color: '#fff', marginBottom: 10 }}>Select dataframe columns</div>
        <OptionBar>
          <div>
            {selectedOptions.map(opt => (
              <span key={opt} style={{ background: '#ef5350', color: '#fff', borderRadius: 6, padding: '6px 12px', marginRight: 8, fontSize: 16 }}>{labourCostData.find(o => o.type === opt)?.label || opt.charAt(0).toUpperCase() + opt.slice(1)} &#10005;</span>
            ))}
          </div>
          <OptionBarDropdown
            value={dropdownValue}
            onChange={e => {
              setDropdownValue(e.target.value);
              if (!selectedOptions.includes(e.target.value)) {
                setSelectedOptions([...selectedOptions, e.target.value]);
              }
            }}
            displayEmpty
            input={<InputBase />}
          >
            <MenuItem value="quantity">Quantity</MenuItem>
            <MenuItem value="quantityUnits">Quantity units</MenuItem>
            <MenuItem value="totalCost">Total Cost</MenuItem>
          </OptionBarDropdown>
        </OptionBar>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', background: '#23272f', color: '#fff', borderRadius: 10, borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Type</th>
                <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Quantity</th>
                <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Quantity units</th>
                <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: 600 }}>Total Cost</th>
              </tr>
            </thead>
            <tbody>
              {labourCostData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.type}</td>
                  <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.quantity}</td>
                  <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.quantityUnits}</td>
                  <td style={{ padding: '12px 16px', borderTop: '1px solid #333' }}>{row.totalCost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ color: '#fff', fontSize: 32, textAlign: 'center', marginTop: 30 }}>
          €11,594,365.63
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, p: 2 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            disabled={!processed}
            sx={{
              bgcolor: processed ? '#43a047' : '#FFD699',
              color: processed ? '#fff' : '#222',
              fontWeight: 600,
              boxShadow: 'none',
              borderRadius: 1,
              '&:hover': { bgcolor: processed ? '#388e3c' : '#FFC966' },
              '&.Mui-disabled': {
                bgcolor: processed ? '#43a047' : '#FFD699',
                color: processed ? '#fff' : '#222',
                opacity: 1,
              },
            }}
          >
            {processed ? 'Processed' : 'Not Processed'}
          </Button>
          {processing ? (
            <Button
              variant="contained"
              disabled
              sx={{
                bgcolor: '#90caf9',
                color: '#222',
                fontWeight: 600,
                boxShadow: 2,
                borderRadius: 1,
                '&.Mui-disabled': {
                  bgcolor: '#90caf9',
                  color: '#222',
                  opacity: 1,
                },
              }}
              startIcon={<CircularProgress size={24} color="inherit" />}
            >
              PROCESSING...
            </Button>
          ) : (
            <Button
              variant="contained"
              sx={{
                bgcolor: '#42A5F5',
                color: '#fff',
                fontWeight: 600,
                boxShadow: 2,
                borderRadius: 1,
                '&:hover': { bgcolor: '#1E88E5' },
              }}
              onClick={handleProcess}
              disabled={processed}
            >
              PROCESS
            </Button>
          )}
        </Box>
        <Box sx={{ mt: 2 }}>
          <img src={image1} alt="Fiber Design" style={{ maxWidth: 1300, height: 400, width: '100%', objectFit: 'cover', borderRadius: 8 }} />
        </Box>
        {processed && (
          <Box sx={{ width: '100%', mt: 4 }}>
            <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)}>
              <Tab label={<span style={{ fontWeight: 700, color: '#1976d2' }}>DESIGN</span>} />
              {/* <Tab label={<span style={{ fontWeight: 500 }}>DETAILS</span>} /> */}
              <Tab label={<span style={{ fontWeight: 500 }}>Building Attributes</span>} />
              <Tab label={<span style={{ fontWeight: 500 }}>Material Cost Breakdown</span>} />
              <Tab label={<span style={{ fontWeight: 500 }}>Labor Cost Breakdown</span>} />
            </Tabs>
            <Box sx={{ mt: 3 }}>
              {tabIndex === 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', width: '130%' }}>
                  <img src={image2} alt="Design" style={{ maxWidth: 1150, height: 400, width: '100%', borderRadius: 8, marginRight: 32 }} />
                  {/* You can add content to the right if needed */}
                </Box>
              )}
              {tabIndex === 1 && <BuildingAttributesTable />}
              {tabIndex === 2 && <MaterialCostBreakdownTable />}
              {tabIndex === 3 && <LabourCostBreakdownTable />}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}
